export const OUTLOOK_TEMPLATE_ID = 'outlook-local';

/** Where the Outlook server's Microsoft sign-in stands */
export type OutlookSignInState =
  | { state: 'signed_in'; email?: string }
  | { state: 'code'; url: string; code: string }
  | { state: 'pending' };
